import { c as _c } from "react/compiler-runtime";
import { useContext, type UIEventHandler } from 'react';
import { ScrollableContext } from './scrollableContext';
export const useScrollable = () => {
  const context = useContext(ScrollableContext);
  if (!context) {
    throw new Error("useScrollable must be used within a ScrollableWrapper");
  }
  return context;
};

/**
 * The scroll handler a virtualized list hands back to the header above it. Such a
 * list scrolls inside its own scroller rather than in {@link ScrollableContent}, so
 * the header only learns it is scrolled — and casts its shadow — if the list says so.
 */
export const useVirtualizedScrollShadow = () => {
  const $ = _c(3);
  const {
    isScrolledVertically,
    setIsScrolledVertically
  } = useScrollable();
  let t0;
  if ($[0] !== isScrolledVertically || $[1] !== setIsScrolledVertically) {
    t0 = event => {
      const isScrolled = event.currentTarget.scrollTop > 0;
      if (isScrolled !== isScrolledVertically) {
        setIsScrolledVertically(isScrolled);
      }
    };
    $[0] = isScrolledVertically;
    $[1] = setIsScrolledVertically;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};